import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const LanguageTestSelectionInfo = () => (
  <Box component={Paper} sx={{ p: 2 }}>
    <Typography variant="h6" gutterBottom>Choosing a Language Test</Typography>
    <Typography paragraph>
      To prove your language proficiency, you must take a test from an agency designated by Immigration, Refugees and Citizenship Canada (IRCC). There are currently three tests for English (IELTS General Training, CELPIP-General, PTE Core) and two for French (TEF Canada, TCF Canada).
    </Typography>
    <Typography paragraph>
      Each test has a unique format and user experience. Your choice can be strategic. Consider factors like:
    </Typography>
    <ul>
      <li><Typography><strong>Test Format:</strong> Computer-based vs. paper-based options.</Typography></li>
      <li><Typography><strong>Speaking Test:</strong> Interaction with a human examiner (IELTS, TEF, TCF) vs. responding to computer prompts (CELPIP, PTE Core).</Typography></li>
      <li><Typography><strong>Content Focus:</strong> Canadian English and context (CELPIP) vs. International English (IELTS, PTE Core).</Typography></li>
      <li><Typography><strong>Availability:</strong> Test center locations and dates.</Typography></li>
    </ul>
    <Typography paragraph>
      All test results are valid for two years from the date of issue and must be valid when you submit your Express Entry profile and your final application for permanent residence. A careful review of the test formats is a crucial part of effective preparation.
    </Typography>
  </Box>
);

export default LanguageTestSelectionInfo;